import axios from "axios";

export async function getApi(param) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/page/${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}
export async function getMediaList(param) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/page/media-page?status=${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getServices(param) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/service/${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getMedia(param) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/media/${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getProjects(param) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/project/${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getProjectSort(status, type, location, collection, area, page ) {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/page/projects?project_status=${status}&project_type=${type}&project_location=${location}&project_collection=${collection}&project_feature=${area}&page=${page}`,
        {
            cache:"no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getOptions() {
    const response = await fetch(
        `https://cms.ups-bd.com/wp-json/myapp/v1/options`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}
